import { useEffect, useRef } from 'react';
import type { FieldErrors, FieldValues } from 'react-hook-form';

const SEPARATOR = ',';

export const useScrollToErrorField = (errorFields: FieldErrors<FieldValues>) => {
  const scrolled = useRef(false);

  // https://github.com/react-hook-form/react-hook-form/issues/612#issuecomment-1307594057
  // using a state here to make the "scroll & focus" happen once per submission
  const errorKeys = Object.keys(errorFields).sort().join(SEPARATOR);

  useEffect(() => {
    if (!errorKeys) {
      scrolled.current = false;

      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    }

    if (scrolled.current) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      return () => {};
    }

    const timeoutId = setTimeout(() => {
      const [errorElement] = errorKeys
        .split(SEPARATOR)
        .map((name) => document.getElementsByName(name)[0])
        .filter((el) => !!el)
        // Sort inputs based on their position on the page. (the order will be based on validaton order otherwise)
        .sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);

      if (errorElement) {
        errorElement.style.scrollMarginTop = '100px';
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' }); // scrollIntoView options are not supported in Safari
        errorElement.focus({ preventScroll: true });
        scrolled.current = true;
      }
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [errorKeys]);
};
